import React from 'react';
import { DatePicker } from "antd";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

const DatePickerMenu = ({ onChange }) => {

  const disabledDate = (current) => {
    // Se nada foi selecionado ainda, tudo liberado
    if (!selectedRange || selectedRange.length === 0) return false;

    const [start] = selectedRange;

    if (!start) return false;

    // Limita 1 ano para frente e para trás
    const oneYearAfter = dayjs(start).add(1, "year");
    const oneYearBefore = dayjs(start).subtract(1, "year");

    return current > oneYearAfter || current < oneYearBefore;
  };

  const [selectedRange, setSelectedRange] = React.useState([]);

  return (
    <RangePicker
      onCalendarChange={(dates) => setSelectedRange(dates)}
      disabledDate={disabledDate}
      format="DD/MM/YYYY"
      onChange={onChange}
    />
  );
};

export default DatePickerMenu;

